module.exports = __webpack_public_path__ + "img/img_series_102.bb6edffa.png";